module.exports = __webpack_public_path__ + "img/board_lable.7f8c8a4c.png";